export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11334.f677e8f8.jpg";